import { ContentWrapper } from "../../components/Wrappers/Wrappers"
import { Title, Text } from "../../components/units/Text"
import { useSignedInContext } from "../../context/AuthContextProvider"
import { useValidatePermission } from "../../roles/roles"
import { BoxWrapper, FlexWrapper } from "../../components/Wrappers/Wrappers"
import { CreateUserProps, AxiosCreateOrganization } from "../../components/Rest/RestStaffOrganization"
import { Input } from "../../components/Form/FormInput"
import { SubmitButton } from "../../components/Buttons/buttons"
import { RestApiState } from "../../interfaces/Rest/types"
import { ImageInput } from "../../components/Form/ImageInput"
import { useEffect, useState } from "react"


interface ResponseProps {
    errors: {
        phone?: string;
        email?: string;
        organization_id?: string;
    },
    requestState: RestApiState;
    timeOutId: NodeJS.Timeout | undefined;
    created: boolean;
}


const defaultResponse = (): ResponseProps => {
    return {
        errors: {

        },
        requestState: RestApiState.Idle,
        timeOutId : undefined,
        created: false
    }
}


export const CreateOrganization = () => {
    const { user } = useSignedInContext()

    useValidatePermission({ role : user.role, resource: 'Organization', action: 'create' })
    
    const [img, setImg] = useState(undefined)
    const [response, setResponse] = useState<ResponseProps>(defaultResponse)

    useEffect(() => { 
        if (response.requestState === RestApiState.Success) {
            setResponse(prev => ({...prev,  created: true}))
        }
    }, [response.requestState])

    const handleSubmit = (event: any) => {
        event.preventDefault();
        setResponse(prev => ({...prev, errors:{}}))

        const formData = new FormData(event.currentTarget)
        const formValues: Record<string, any> = {};
        formData.forEach((value, key) => {
            formValues[key] = value as any; // Cast value to string if necessary
        });
        formValues['username'] = formValues.email
        if (formValues.role === '1' && formValues.organization_id === "Не выбрано") {
            setResponse(prev => ({...prev, errors: {
                ...prev.errors, organization_id: "Нужно выбрать организацию"
            }}))
            return ;
        }

        setResponse(prev => ({...prev, requestState: RestApiState.Pending}))
        AxiosCreateOrganization(
            (formValues as CreateUserProps), 
            (value: RestApiState) => {
                setResponse(prev => ({...prev, requestState: value}))
            },
            (value: any) => {
                for (const [key, val] of Object.entries(value)) {
                    setResponse(prev => ({...prev, errors: {
                        ...prev.errors, [key]: "Неверное значение или дубль"
                    }}))
                }
            }
        )
    }

    return (
        <ContentWrapper>
            <Title>Добавить организацию</Title>
            <br />
            <BoxWrapper 
                bg="bg-primary"
                p="p2"
                r="r10"
                style={{
                    maxWidth: "640px"
                }} 
            >
                { !response.created ? (
                    <form onSubmit={ handleSubmit }>
                        <FlexWrapper justifyContent="center">
                            <BoxWrapper>
                                <ImageInput 
                                    disabled={false}
                                    name="organization_image"
                                    size="base"
                                    defaultImg="profile"
                                    previewImg={img}
                                    setPreview={{
                                        action: "",
                                        key: "",
                                        setValue: (action:string, key:string, value: any) => { setImg(value) }
                                    }}
                                />
                                <Text color="secondary" className="text-center">Фото</Text>
                            </BoxWrapper>
                        </FlexWrapper>
                        <Input name="organization_name"
                            label="Название"
                            required={true}
                            type='text'
                            inputError={response.errors.email}
                        />
                        <Input name="address"
                            label="Адрес"
                            required={true}
                            type='text'
                            inputError={response.errors.email}
                        />
                        
                        <Input name="email"
                            label="Почта"
                            required={true}
                            type='text'
                            inputError={response.errors.email}
                        />
                        <Input name="phone"
                            label="Телефон"
                            required={true}
                            type='text'
                            inputError={response.errors.phone}
                        />
                        <SubmitButton 
                            restState={response.requestState}
                            disabled={false}
                            restHandler={{
                                timeOutId: null,
                                setter: (key: "timeOutId" | "requestState", value: any) => {
                                    setResponse(prev => ({...prev, [key]: value}))
                                }
                            }}
                        />
                    </form>
                ) : (
                    <BoxWrapper className="show-up-quick">
                        <FlexWrapper>
                            <Text className="bold">Организация успешно создана ✅</Text>
                        </FlexWrapper>
                    </BoxWrapper>
                ) }
            </BoxWrapper>
        </ContentWrapper>
    )
}